import { render, staticRenderFns } from "./CNotification.vue?vue&type=template&id=600f4ee6&"
import script from "./CNotification.vue?vue&type=script&lang=js&"
export * from "./CNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports